<template>
  <div :class="className" :style="styles">
    <div :class="small ? 'web-gl small-border' : 'web-gl position-web-full'">
      <div class="gem-detail relative" id="gem-detail" :style="styles">
        <div
          v-if="!pageFullScreen && !small"
          class="close"
          @click="closeFull"
        ></div>
        <div class="bottom" v-if="showFull && type === 'web' && !finish.webGl">
          <div class="btn full cursor-pointer" @click="full" title="全屏"></div>
        </div>
        <div
          class="
            handle-group flex-row justify-around"
          :style="!showFull && type === 'web' ? '' : 'width:110px;'"
        >
          <div
            class="btn zoomIn cursor-pointer"
            title="放大"
            @click="zoomIn()"
          ></div>
          <div
            class="btn zoomOut cursor-pointer"
            title="缩小"
            @click="zoomOut()"
          ></div>
          <div
            v-if="!showFull && type === 'web'"
            class="btn transform cursor-pointer"
            title="收起"
            @click="closeFull"
          ></div>
        </div>
        <canvas id="example" :style="styles"></canvas>
        <div class="load" v-if="finish.webGl">
          <img src="../../../../static/images/gem/loading.gif" alt="" />
          <div class="text-load">{{ tip }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'three'
import '../include/jsmodeler.ext.three.js'
import JSZip from 'jszip'
import axios from 'axios'
import ImporterApp from '../include/importerapp.js'
var importerApp = new ImporterApp()
var fileList = null

export default {
  name: 'web-gl',
  props: {
    url: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'web'
    },
    styleObject: {
      type: Object,
      default: null
    },
    fullStyleObject: {
      type: Object,
      default: null
    },
    pageFullScreen: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      small: true,
      showFull: true,
      styles: { width: '', height: '' },
      promises: [],
      loadWebGl: true,
      finish: importerApp.loading,
      tip: '模型加载中...'
    }
  },
  computed: {
    className() {
      let name = ''
      if (this.small && this.type === 'web') {
        name = ''
      } else if (!this.small) {
        name = 'web-full-container'
      } else if (this.small && this.type === 'mini') {
        name = 'mini-container'
      }
      return name
    }
  },
  watch: {
    styleObject(val) {
      if (val && this.type === 'web') {
        this.styles = this.styleObject
      }
    }
  },
  methods: {
    zoomIn() {
      importerApp.ZoomIn()
    },
    zoomOut() {
      importerApp.ZoomOut()
    },
    closeFull() {
      this.small = true
      this.showFull = true
      if (importerApp) {
        if (!this.styleObject) {
          this.styles.width = '830px'
          this.styles.height = '700px'
        } else {
          this.styles = this.styleObject
        }
        setTimeout(function() {
          var e = document.createEvent('Event')
          e.initEvent('resize', true, true)
          window.dispatchEvent(e)
        }, 0.1 * 100)
      }
    },
    full() {
      // eslint-disable-next-line no-console
      console.log(this.$parent)
      this.showFull = false
      this.small = false
      if (importerApp) {
        if (!this.fullStyleObject) {
          this.styles.width = '1200px'
          this.styles.height = '700px'
        } else {
          this.styles = this.fullStyleObject
        }

        setTimeout(function() {
          var e = document.createEvent('Event')
          e.initEvent('resize', true, true)
          window.dispatchEvent(e)
        }, 0.1 * 100)
      }
    }
  },
  mounted() {
    this.finish.webGl = true

    if (this.type === 'web' && !this.styleObject) {
      this.styles.width = '830px'
      this.styles.height = '690px'
    } else {
      this.styles = this.styleObject
    }
    // eslint-disable-next-line no-console
    console.log(this.fullStyleObject)
    this.tip = '下载模型文件中...'
    axios({
      url: this.url,
      method: 'GET',
      responseType: 'blob',
      withCredentials: true
    })
      .then(res => {
        this.tip = '模型文件解压中...'
        var data = new Blob([res.data])
        var zip = new JSZip()
        var blobArr = []
        zip.loadAsync(data).then(response => {
          for (var k in response.files) {
            // 跳过无用的隐藏文件，跳过目录
            if (
              k.indexOf('__') === 0 ||
              k.indexOf('.') === 0 ||
              response.files[k].dir
            ) {
              continue
            }
            blobArr.push(response.files[k])
          }
          blobArr.forEach(el => {
            let index = el.name.indexOf('/')
            this.promises.push(
              el
                .async('blob')
                .then(
                  res =>
                    new File([res], el.name.slice(index + 1, el.name.length))
                )
            )
          })
          Promise.all(this.promises).then(res => {
            fileList = res
            this.tip = '初始化模型文件...'
            importerApp.Init(fileList)
          })
        })
      })
      .catch(() => {
        this.$swal({
          position: 'top-end',
          type: 'error',
          toast: true,
          text: '模型文件下载失败',
          showConfirmButton: false,
          timer: 3000
        })
      })
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.gem-detail {
  position: relative;
}
.load {
  width: 6rem;
  height: 5rem;
  position: absolute;
  top: 45%;
  left: 50%;
  text-align: center;
  transform: translateX(-50%);
}
.load img {
  width: 1.5rem;
  height: 1.5rem;
}
.load .text-load {
  font-size: 0.18rem;
  padding-top: 0.4rem;
  color: #8c8174;
}
.web-full-container {
  background-color: #000;
  padding: 10px;
  width: 1200px;
  height: 700px;
  position: absolute;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.position-web-full {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.small-border {
  // border: 2px solid #000;
}
.close {
  cursor: pointer;

  width: 44px;
  height: 44px;
  line-height: 44px;
  border-radius: 0;
  background: url('../../../../static/images/public/close-square.png') center
    no-repeat;
  background-size: 60% 60%;
  background-color: $c-transparent-6;
  position: absolute;
  top: 0;
  right: -44px;
}
.close:hover {
  transition: 0.5s;
  background-image: url('../../../../static/images/public/close-square-hover.png');
}
.big-border {
  border: 2px solid rgba(255, 255, 255, 0.3);
}
.handle-group {
  position: absolute;
  bottom: 22px;
  left: 22px;
  width: 140px;
  height: 32px;
  box-sizing: border-box;
  align-items: center;
}
.btn {
  width: 35px;
  height: 35px;
  line-height: 35px;
  font-size: 20px;
}
.btn:hover {
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
}
.full {
  background-image: url('../../../../static/images/porcelain/icon-btn.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.transform {
  background-image: url('../../../../static/images/porcelain/icon-transfer.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.zoomIn {
  background-image: url('../../../../static/images/porcelain/zoom-in.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.zoomOut {
  background-image: url('../../../../static/images/porcelain/zoom-out.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.bottom {
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: #ffffff;
}
.mini-container {
  .zoomIn,
  .zoomOut {
    display: none;
  }
}
</style>
